import { FiltersRepository } from '@/infrastructure/session-storage'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router'

const filtersRepository = new FiltersRepository()

const getDependencies = {
  getURLSessionFilters:
    filtersRepository.getURLSessionFilters.bind(filtersRepository)
}

const clearDependencies = {
  clearURLSessionFilters:
    filtersRepository.clearURLSessionFilters.bind(filtersRepository)
}

function getSessionFilters({ getURLSessionFilters }: typeof getDependencies) {
  return getURLSessionFilters()
}

export function useSessionFilters() {
  const [searchParams, setSearchParams] = useSearchParams()
  const [loadingPreviousFilters, setLoadingPreviousFilters] = useState(true)

  function clearSessionFilters({
    clearURLSessionFilters
  }: typeof clearDependencies) {
    setLoadingPreviousFilters(true)
    clearURLSessionFilters()
    setSearchParams(new URLSearchParams(), { replace: true })
    setTimeout(() => setLoadingPreviousFilters(false), 0)
  }

  const sessionFilters = getSessionFilters(getDependencies)

  useEffect(() => {
    if (!sessionFilters || searchParams.size) {
      setLoadingPreviousFilters(false)
      return
    }
    const urlSearchParams = new URLSearchParams(sessionFilters)
    setSearchParams(urlSearchParams, { replace: true })
    setLoadingPreviousFilters(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    loadingPreviousFilters,
    sessionFilters,
    clearSessionFilters: () => clearSessionFilters(clearDependencies)
  }
}
